<div class="detail-box" [ngClass]="isActive || changeService.isActive ? 'active-mobile' : ''">
  <div class="profile change-pass">
    <div class="mobile_head">
      <a href="JavaScript:void(0)" (click)="remove()" class="back_link">
        <span class="icon-arrow-left"></span>
      </a>
      <h4>{{ "CHANGE_PASSWORD_INFO.CHANGE_PASSWORD" | translate }}</h4>
    </div>
    <form class="account-body" (ngSubmit)="resetPasswordForm.form.valid && resetPassword(resetPasswordForm)"
      #resetPasswordForm="ngForm" role="form">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <div class="form-group password-in label-ic">
            <label>{{ "CHANGE_PASSWORD_INFO.OLD_PASSWORD" | translate }}</label>
            <div class="field-icon">
              <span class="material-icons"> lock_open </span>
            </div>
            <div class="pass-ic">
              <span class="icon-eye-closed" (click)="changePasswordType('oldPassword')" [ngClass]="{
                  'icon-eye-icon': oldPasswordType == 'password',
                  'icon-eye-closed': oldPasswordType != 'password'
                }"></span>
              <!-- <span class="icon-eye-icon"></span> -->
            </div>
            <input type="{{ oldPasswordType }}" name="old_password" class="with-icon-field form-control" placeholder="{{
                'CHANGE_PASSWORD_INFO.OLD_PASSWORD' | translate
              }}" [(ngModel)]="model.old_password" #old_password="ngModel" required />
            <div style="color: red" class="validation_div" *ngIf="
                old_password.errors &&
                (old_password.dirty || resetPasswordForm.submitted)
              ">
              <p class="mb-0" *ngIf="old_password.errors.required">
                {{ "CHANGE_PASSWORD_INFO.OLD_PWD_REQUIRED" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12">
          <div class="form-group password-in label-ic">
            <label>
              {{ "CHANGE_PASSWORD_INFO.NEW_PASSWORD" | translate }}</label>
            <div class="field-icon">
              <span class="material-icons"> lock_open </span>
            </div>
            <div class="pass-ic">
              <span class="icon-eye-closed" (click)="changePasswordType('newPassword')" [ngClass]="{
                  'icon-eye-icon': newPasswordType == 'password',
                  'icon-eye-closed': newPasswordType != 'password'
                }"></span>
              <!-- <span class="icon-eye-icon"></span> -->
            </div>
            <input minlength="6" maxlength="30" type="{{ newPasswordType }}" validateEqual="old_password"
              name="new_password" class="with-icon-field form-control" placeholder="{{
                'CHANGE_PASSWORD_INFO.NEW_PASSWORD' | translate
              }}" [(ngModel)]="model.new_password" #new_password="ngModel" required />
            <div class="validation_div">
              <p class="text-danger ml-2 mb-0" *ngIf="
                  model.old_password === model.new_password &&
                  !new_password.errors &&
                  (model.old_password || model.new_password)
                ">
                {{ "CHANGE_PASSWORD_INFO.SAME_PWD" | translate }}
              </p>
            </div>

            <div style="color: red" class="validation_div" *ngIf="
                new_password.errors &&
                (new_password.dirty || resetPasswordForm.submitted)
              ">
              <p class="mb-0" *ngIf="new_password?.errors?.required">
                {{ "CHANGE_PASSWORD_INFO.NEW_PASSWORD_REQUIRED" | translate }}
              </p>
              <p class="mb-0" *ngIf="new_password?.errors?.minlength">
                {{ "CHANGE_PASSWORD_INFO.PWD_LENGTH_REQUIRED" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12">
          <div class="form-group password-in label-ic">
            <label>
              {{ "CHANGE_PASSWORD_INFO.CONFIRM_PASSWORD" | translate }}</label>
            <div class="field-icon">
              <span class="material-icons"> lock_open </span>
            </div>
            <div class="pass-ic">
              <span class="icon-eye-closed" (click)="changePasswordType('confirmPassword')" [ngClass]="{
                  'icon-eye-icon': confirmPasswordType == 'password',
                  'icon-eye-closed': confirmPasswordType != 'password'
                }"></span>
              <!-- <span class="icon-eye-icon"></span> -->
            </div>
            <input minlength="6" maxlength="30" validateEqual="new_password" reverse="false" id="password"
              class="with-icon-field form-control" [(ngModel)]="model.confirm_password" name="confirm_password"
              #confirm_password="ngModel" type="{{ confirmPasswordType }}" placeholder="{{
                'CHANGE_PASSWORD_INFO.CONFIRM_PASSWORD' | translate
              }}" required />
            <div class="validation_div">
              <p class="text-danger ml-2 mb-0" *ngIf="
                  model?.confirm_password != model?.new_password &&
                  !confirm_password?.errors?.minlength &&
                  !confirm_password?.errors?.required
                ">
                {{ "CHANGE_PASSWORD_INFO.NEW_PWD_MISMATCH" | translate }}
              </p>
              <p class="text-danger ml-2 mb-0" *ngIf="confirm_password?.errors?.minlength">
                {{ "CHANGE_PASSWORD_INFO.CPWD_LENGTH" | translate }}
              </p>
              <p class="text-danger ml-2 mb-0" *ngIf="
                  confirm_password?.errors?.required &&
                  (confirm_password?.dirty || resetPasswordForm.submitted)
                ">
                {{
                "CHANGE_PASSWORD_INFO.CONFIRM_PASSWORD_REQUIRED" | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-3">
        <button type="submit" class="btn btn-theme"
          [disabled]="!resetPasswordForm.valid || model?.confirm_password != model?.new_password">
          <span class="spin icon-loader" *ngIf="isLoading"> </span>
          {{ "CHANGE_PASSWORD_INFO.SUBMIT" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>